<template>
  <div :class="['action-bar', { 'is-mobile': isMobile, 'is-disabled': isDisabled }]">
    <slot />
  </div>
</template>

<script setup lang="ts">
import { isMobile } from '@/core/helpers/ui.helper';

export interface ActionBarProps {
  isDisabled?: boolean;
}

defineProps<ActionBarProps>();
</script>

<style lang="scss" scoped>
.action-bar {
  display: flex;
  align-items: center;
  position: relative;

  justify-content: space-between;
  gap: var(--spacing-l);
  gap: 12px;

  width: 100%;
  /* Inside a Spark card the gutter scales with the card so the bar stays aligned
     with the text above it. Vertical padding is a touch target, so it does not. */
  padding: 12px var(--card-gutter, var(--spacing-h));
  min-height: 59px;

  border-bottom-left-radius: var(--radius-normal);
  border-bottom-right-radius: var(--radius-normal);

  background: var(--color-fabric-gradient-darker);
}

.action-bar.is-mobile {
  padding: 10px var(--card-gutter, var(--spacing-h));

  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

.action-bar .chess-set-switch {
  display: none;
}
</style>
